import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  exportTableColumnValidation,
  tableColumnValidation,
  TableSettingColumn,
} from 'types/tableSettingsTypes';

interface AdminSubscriptionPlanState {
  filterData: Record<string, any>;
  reloadTableData: boolean;
  tableColumnValidation: tableColumnValidation;
  defaultColumnList: TableSettingColumn[];
  tableColumnList: TableSettingColumn[];
  exportTableColumnValidation: exportTableColumnValidation;
  exportTableColumnList: TableSettingColumn[];
}
const defaultColumnList = [
  {
    name: 'name',
    label_key: 'name',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    order: 1,
  },
  {
    name: 'status',
    label_key: 'status',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    type: 'select',
    filter_placeholder: 'status_all',
    selectKey: 'status',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 3,
  },
];
const mappedList = defaultColumnList.map((list) => ({
  ...list,
  allow_list: true,
  show_list_checkbox: true,
}));

const exportColumnList = [
  ...mappedList.slice(0, 1),
  {
    name: 'description',
    label_key: 'description',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 2,
  },
  ...mappedList.slice(1),
];
const initialState: AdminSubscriptionPlanState = {
  filterData: {},
  reloadTableData: false,
  tableColumnValidation: {
    minListColumn: 2,
    maxListColumn: 8,
    minFilterColumn: 0,
    maxFilterColumn: 8,
  },
  defaultColumnList: defaultColumnList,
  tableColumnList: JSON.parse(JSON.stringify(defaultColumnList)),
  exportTableColumnValidation: {
    minListColumn: 2,
  },
  exportTableColumnList: exportColumnList,
};

const adminSubscriptionPlanSlice = createSlice({
  name: 'adminSubscriptionPlan',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = { ...state.filterData, ...action.payload };
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
    setSubscriptionPlanTableColumnList(state, action: PayloadAction<TableSettingColumn[]>) {
      state.tableColumnList = action.payload;
    },
  },
});

export const {
  setFilterData,
  resetFilterData,
  setReloadTableData,
  setSubscriptionPlanTableColumnList,
} = adminSubscriptionPlanSlice.actions;

export default adminSubscriptionPlanSlice.reducer;
